/* Other Routes */
export const ROOT = '/';
export const EMPTY = '';
export const WILDCARD = '*';
export const DEV = '/dev';
export const AUTH = "/auth";
export const APP = "/app";
export const SIGN_UP = "/sign-up";
export const DUMMY = "/dummy"

/* Auth Routes */
export const REGISTER = AUTH + "/register";
export const LOGIN = AUTH + "/login";
export const LOGIN_OTP = AUTH + "/login/otp";
export const RESET_PASSWORD = AUTH + "/reset-password";
export const FORGOT_PASSWORD = AUTH + "/forgot-password";

/* Register Routes */
export const CREATE_ACCOUNT = "/:type/create-account";
export const BASIC_INFO = SIGN_UP + "/basic-info";
export const GROUP_DETAILS = SIGN_UP + "/group-details";
export const ADMIN_DETAILS = SIGN_UP + "/admin-details";
export const MEMBER_DETAILS = SIGN_UP + "/member-details";
export const DOCUMENTS_UPLOAD = SIGN_UP + "/documents-upload";
export const RISK_ASSESSMENT = SIGN_UP + "/suitability-quiz";
export const SUBSCRIPTIONS = "/subscription-plans";
export const ORDER = "/order";
export const WITHDRAWAL_REQUEST = "/withdrawal-request"

/* Home Route */
export const HOME = APP + "/home";
export const HOLDINGS = APP + "/holdings";
export const WALLET = APP + "/wallet";
export const REPORT = APP + "/report";
export const PROFILE = APP + "/profile";
export const REFER = APP + "/refer";
export const FAQ = APP + "/faq";
export const REACH_US = APP + "/reach-us";
export const SSO_REDIRECTION = "/google/callback"
export const APPLE_CALLBACK = "/apple/auth"